// import React from 'react'
// import TopBar from '../components/TopBar'
// import { AuroraBackgroundDemo } from '../components/aurora-bg'
// import { VortexDemo } from '../components/bg-vortex'
// import { BackgroundBeams } from '../ui/background-beams'

// const PagePreview = ({ children }) => {
//   return (
//     <div className='h-screen bg-animated relative overflow-hidden bg-[var(--bg-blue)]'>
//       {/* <AuroraBackgroundDemo> */}
//       <VortexDemo>
//         <div
//           className='absolute w-[100px] h-[100px] bottom-0'
//           style={{
//             backgroundImage: "url('/images/arrowCorner.svg')",
//             backgroundSize: 'cover',
//             backgroundPosition: 'center',
//             backgroundRepeat: 'no-repeat',
//           }}
//         ></div>

//         <div className='relative h-screen z-10 overflow-hidden'>
//           <div className='max-w-[1440px] mx-auto px-4 '>{children}</div>
//         </div>
//       </VortexDemo>
//       {/* </AuroraBackgroundDemo> */}
//       <BackgroundBeams />
//     </div>
//   )
// }

// const Layout = ({ children }) => {
//   return (
//     <>
//       <PagePreview>
//         {/* Logo */}
//         <TopBar />

//         {children}
//       </PagePreview>
//     </>
//   )
// }

// export default Layout


import React from 'react'
import TopBar from '../components/TopBar'
import { AuroraBackgroundDemo } from '../components/aurora-bg'
import { VortexDemo } from '../components/bg-vortex'
import { BackgroundBeams } from '../ui/background-beams'

const PagePreview = ({ children }) => {
  return (
    <div className='h-screen bg-animated bg-[#065AD8] relative overflow-hidden'>
      <AuroraBackgroundDemo>
        <VortexDemo>
          {/* <div class='bg-wrapper'>
          <div class='five'></div>
          <div class='six'></div>
          <div class='seven'></div>
          <div class='eight'></div>
        </div> */}
          {/* <div
            className='absolute top-1/2 opacity-10 left-1/2 right-1/2 bottom-1/2 -translate-x-1/2 -translate-y-1/2 w-[110%] h-[110%]'
            style={{
              backgroundImage: "url('/images/wave2.svg')",
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }}
          ></div> */}
          {/* <div
            className='absolute top-0 w-full h-full -left-[10%]'
            style={{
              backgroundImage: "url('/images/highlight.svg')",
              backgroundSize: 'contain',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }}
          ></div> */}

          <div
            className='absolute w-[100px] h-[100px] bottom-0'
            style={{
              backgroundImage: "url('/images/arrowCorner.svg')",
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
            }}
          ></div>

          <div className='relative h-screen z-10 overflow-hidden'>
            <div className='max-w-[1440px] mx-auto px-4 '>{children}</div>
          </div>
        </VortexDemo>
      </AuroraBackgroundDemo>
      <BackgroundBeams />
    </div>
  )
}

const Layout = ({ children }) => {
  return (
    <>
      <PagePreview>
        {/* Logo */}
        <TopBar />

        {children}
      </PagePreview>
    </>
  )
}

export default Layout
